import type { ConditionsMatcher, MatchConditions } from '@casl/ability';
import type {
    FilterableSubjectKey,
    SubjectConditions,
    SubjectKey,
    SubjectKeyWithCondition,
    SubjectObject,
} from '../../types/acl-types.ts';

type MatcherFn<K extends SubjectKey> = (
    conditions: SubjectConditions<K>,
    object: SubjectObject<K>,
) => boolean;

type ConditionsMatcherMap = {
    [TKey in Exclude<
        SubjectObject['kind'] & SubjectKeyWithCondition,
        `${FilterableSubjectKey}Filter`
    >]: MatcherFn<TKey>;
};

const conditionsMatchers = {
    Task: ({ assignedByIds, assignedToIds }, { assignedById, assignedToId }) => {
        if (assignedToIds?.length && (!assignedToId || !assignedToIds.includes(assignedToId))) {
            return false;
        }

        if (assignedByIds?.length && (!assignedById || !assignedByIds.includes(assignedById))) {
            return false;
        }

        return true;
    },
    Customer: ({ salesRepIds }, { rep_id }) => {
        if (salesRepIds?.length && !salesRepIds.includes(rep_id)) {
            return false;
        }

        return true;
    },
    SalesReport: () => {
        throw new Error('Not implemented');
    },
    QuoteOrder: ({ salesRepIds }, { sales_reps }) => {
        if (salesRepIds?.length && !sales_reps.some((rep) => salesRepIds?.includes(rep.id))) {
            return false;
        }

        return true;
    },
    Stats: () => {
        throw new Error('Not implemented');
    },
    SalesDraft: () => {
        throw new Error('Not implemented');
    },
} satisfies ConditionsMatcherMap;

export const conditionsMatcher: ConditionsMatcher<SubjectConditions> = (conditions: SubjectConditions) =>
    (<K extends keyof ConditionsMatcherMap>(object: SubjectObject<K>) =>
        conditionsMatchers[object.kind](
            conditions as any,

            object as any,
        )) as MatchConditions<Record<PropertyKey, any>>;
